import { FINAL_RESULT_TRACKS } from '../../utils/projectTracks';

export const ROLE_OPTIONS = [
  { value: "MEMBER", label: "Участник" },
  { value: "MENTOR", label: "Наставник" },
  { value: "TRACK_COORDINATOR", label: "Координатор треков" },
  { value: "ADMIN", label: "Администратор" },
];
export const SELECTION_OPTIONS = [
  { value: "", label: "Не указан" },
  { value: "NOT_SELECTED", label: "Не прошёл отбор" },
  { value: "CANDIDATE", label: "Кандидат" },
  { value: "PARTICIPANT", label: "Участник" },
  { value: "PARTICIPANT_PRO", label: "Участник Про" },
];
export const TRACK_OPTIONS = [
  ...FINAL_RESULT_TRACKS,
  "ЮФУ.Про Партнеров",
  "ЮФУ.Про Стартапы",
  "ЮФУ.Про Исследования",
  "ЮФУ.Про Общество",
  "ЮФУ.Про Организацию",
].map((value) => ({ value, label: value }));
export const ACCESS_OPTIONS = [
  { value: "", label: "Любой доступ" },
  { value: "active", label: "Активные" },
  { value: "banned", label: "Заблокированные" },
];
export const fullName = (person) =>
  person?.full_name ||
  [person?.last_name, person?.first_name, person?.patronymic]
    .filter(Boolean)
    .join(" ") ||
  person?.login ||
  "Без имени";
export const number = (value) => Number(value || 0).toLocaleString("ru-RU");
export const dateTime = (value) =>
  value
    ? new Date(value).toLocaleString("ru-RU", {
        dateStyle: "short",
        timeStyle: "short",
      })
    : "—";
export const roleLabel = (value) =>
  ROLE_OPTIONS.find((option) => option.value === value)?.label ||
  value ||
  "Не указан";
export const selectionLabel = (value) =>
  SELECTION_OPTIONS.find((option) => option.value === value)?.label ||
  value ||
  "Не указан";
export const accessFilter = (value) => (value ? value === "banned" : undefined);

export function downloadFile(blob, name) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}

export function csvCell(value) {
  const text = String(value ?? "");
  // Spreadsheet cells from user data must remain text rather than formulas.
  return `"${(/^[=+\-@\t\r]/.test(text) ? `'${text}` : text).replace(/"/g, '""')}"`;
}

export const SHOWCASE_FIELDS = [
  {
    name: "title",
    label: "Название кейса",
    required: true,
    minLength: 3,
    maxLength: 255,
    wide: true,
    group: "Основное",
  },
  {
    name: "project_code",
    label: "Код проекта",
    placeholder: "Например, П15",
    maxLength: 32,
  },
  {
    name: "track",
    label: "Трек",
    type: "select",
    options: [{ value: "", label: "Без трека" }, ...TRACK_OPTIONS],
  },
  {
    name: "partner_name",
    label: "Партнёр",
    required: true,
    minLength: 2,
    maxLength: 255,
    wide: true,
  },
  {
    name: "problem",
    label: "Что нужно сделать",
    type: "textarea",
    required: true,
    minLength: 10,
    wide: true,
    hint: "Опишите задачу для команды. Не менее 10 символов.",
  },
  {
    name: "expected_solution",
    label: "Ожидаемый результат",
    type: "textarea",
    wide: true,
    group: "Детали кейса",
  },
  {
    name: "input_data",
    label: "Исходные данные и ограничения",
    type: "textarea",
    wide: true,
  },
  {
    name: "partner_description",
    label: "О партнёре",
    type: "textarea",
    wide: true,
  },
  { name: "rewards", label: "Вознаграждение", type: "textarea", wide: true },
  {
    name: "contacts",
    label: "Контакты партнёра",
    type: "textarea",
    wide: true,
    hint: "Контакты доступны только администраторам.",
  },
  {
    name: "attachments",
    label: "Материалы и ссылки",
    type: "textarea",
    wide: true,
  },
  { name: "location", label: "Локация", maxLength: 160, group: "Публикация" },
  {
    name: "sort_order",
    label: "Порядок в витрине",
    type: "number",
    default: 0,
    hint: "Меньшее число — выше в списке.",
  },
  {
    name: "is_published",
    label: "Опубликовать в витрине",
    type: "checkbox",
    default: false,
    wide: true,
    hint: "Скрытый кейс виден только в админке.",
  },
];
export const SCHEDULE_FIELDS = [
  {
    name: "title",
    label: "Название события",
    required: true,
    maxLength: 255,
    wide: true,
    group: "Событие",
  },
  {
    name: "track_label",
    label: "Трек",
    required: true,
    maxLength: 128,
    wide: true,
    hint: "Выберите существующий или введите новый трек.",
  },
  {
    name: "date_label",
    label: "Дата",
    placeholder: "Например, 24 сентября",
    maxLength: 64,
  },
  {
    name: "time_label",
    label: "Время",
    placeholder: "14:00–15:30",
    maxLength: 64,
  },
  { name: "presenter_name", label: "Спикер", maxLength: 255 },
  {
    name: "format_label",
    label: "Формат",
    placeholder: "Онлайн / очно",
    maxLength: 64,
  },
  { name: "location", label: "Место проведения", maxLength: 500, wide: true },
  {
    name: "description",
    label: "Описание",
    type: "textarea",
    maxLength: 10000,
    wide: true,
  },
  {
    name: "link_url",
    label: "Ссылка на встречу",
    type: "url",
    maxLength: 1000,
    wide: true,
    group: "Встреча и запись",
  },
  {
    name: "recording_url",
    label: "Ссылка на запись",
    type: "url",
    maxLength: 1000,
    wide: true,
  },
  {
    name: "video_url",
    label: "Видео для базы знаний",
    type: "url",
    maxLength: 1000,
    wide: true,
    hint: "Ссылка для встраивания видео (embed).",
  },
  {
    name: "video_preview_url",
    label: "Обложка видео",
    type: "url",
    maxLength: 1000,
    wide: true,
  },
  {
    name: "homework_description",
    label: "Задание для цифрового следа",
    type: "textarea",
    maxLength: 10000,
    wide: true,
    group: "Задание и настройки",
  },
  {
    name: "homework_template_url",
    label: "Ссылка на шаблон задания",
    type: "url",
    maxLength: 1000,
    wide: true,
  },
  {
    name: "sort_order",
    label: "Порядок в расписании",
    type: "number",
    default: 0,
    min: 0,
  },
  {
    name: "is_control_event",
    label: "Контрольное мероприятие",
    type: "checkbox",
    default: false,
    wide: true,
  },
];
export const ACHIEVEMENT_FIELDS = [
  {
    name: "title",
    label: "Название достижения",
    required: true,
    maxLength: 150,
    wide: true,
  },
  {
    name: "description",
    label: "Описание",
    type: "textarea",
    maxLength: 5000,
    wide: true,
  },
  {
    name: "image_url",
    label: "Ссылка на изображение",
    type: "url",
    maxLength: 500,
    wide: true,
    hint: "Необязательно. Укажите прямую ссылку на изображение.",
  },
];
export const ROSTER_FIELDS = [
  { name: "project_code", label: "Код проекта", required: true, maxLength: 32 },
  { name: "track_label", label: "Трек", maxLength: 64 },
  {
    name: "topic",
    label: "Тема проекта",
    type: "textarea",
    maxLength: 2000,
    wide: true,
  },
  { name: "mentor_name", label: "Наставники", maxLength: 255, wide: true },
  {
    name: "chat_url",
    label: "Ссылка на чат",
    type: "url",
    maxLength: 1000,
    wide: true,
  },
  {
    name: "members_text",
    label: "Участники",
    type: "textarea",
    wide: true,
    hint: "Каждый участник — с новой строки. Этот список не меняет состав команды в личных кабинетах.",
  },
];
export function initialForm(fields, item = {}) {
  return Object.fromEntries(
    fields.map((field) => [
      field.name,
      item[field.name] ?? field.default ?? "",
    ]),
  );
}
export function formPayload(fields, form) {
  return Object.fromEntries(
    fields.map((field) => {
      const value = form[field.name];
      if (field.type === "checkbox") return [field.name, Boolean(value)];
      if (field.type === "number") return [field.name, Number(value) || 0];
      const text = String(value ?? "").trim();
      return [field.name, text || (field.required ? "" : null)];
    }),
  );
}
